import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BottomTabBar = ({ activeTab, onTabChange }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabs = [
    { id: 'home', label: 'Home', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
    { id: 'rides', label: 'Rides', icon: 'M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z' },
    { id: 'profile', label: 'Profile', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
    { id: 'account', label: 'Account', icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z' }
  ];

  const handleTabClick = (tabId) => {
    // Use routing for profile and rides
    switch (tabId) {
      case 'profile':
        navigate('/profile');
        break;
      case 'rides':
        navigate('/rides');
        break;
      case 'home':
        // Call onTabChange to update activeTab state, then navigate
        onTabChange?.(tabId);
        navigate('/dashboard');
        break;
      case 'account':
        // Keep HomePage account tab behavior on dashboard, but provide
        // a reliable route fallback from all other pages.
        onTabChange?.(tabId);
        if (location.pathname !== '/dashboard') {
          navigate('/profile');
        }
        break;
      default:
        onTabChange?.(tabId);
        break;
    }
  };

  // Determine active tab based on current route
  const getActiveTab = () => {
    if (location.pathname === '/profile') return 'profile';
    if (location.pathname === '/rides') return 'rides';
    if (location.pathname === '/dashboard') return 'home';
    return activeTab;
  };

  const currentActiveTab = getActiveTab();

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 md:hidden z-[100] shadow-lg"
      style={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: 100,
        backgroundColor: 'white'
      }}
    >
      <div className="flex justify-around items-center py-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab.id)}
            className={`flex flex-col items-center py-2 px-3 rounded-lg transition-all duration-200 ${
              currentActiveTab === tab.id
                ? 'text-primary-600 bg-primary-50'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            <svg
              className={`w-6 h-6 mb-1 ${
                currentActiveTab === tab.id ? 'text-primary-600' : 'text-gray-500'
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d={tab.icon}
              />
            </svg>
            <span className="text-xs font-medium">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BottomTabBar;
